import { z } from "zod";

export const OrderKpisSchema = z.object({
  start: z.string(),
  end: z.string(),
  orders_count: z.number(),
  pending_orders_count: z.number(),
  delivered_orders_count: z.number(),
  cancelled_orders_count: z.number(),
  delivery_orders_count: z.number(),
  pickup_orders_count: z.number(),
  revenue_cents: z.number(),
  sold_kg: z.number(),
  extra_sold_kg: z.number(),
  average_order_value_cents: z.number(),
  throttled_requests_count: z.number(),
  api_requests_count: z.number(),
  api_server_errors_count: z.number(),
  api_error_rate: z.number(),
  abandoned_forms_count: z.number(),
  checkout_form_abandonment_minutes: z.number(),
  status_breakdown: z.record(z.string(), z.number()),
  blueberry_price_trend: z.array(
    z.object({
      date: z.string(),
      avg_unit_price_cents: z.number(),
      sample_size: z.number(),
    }),
  ),
});

export type OrderKpisResponse = z.infer<typeof OrderKpisSchema>;

export const GoogleKpisSchema = z.object({
  start: z.string(),
  end: z.string(),
  analytics: z.object({
    available: z.boolean(),
    active_users: z.number(),
    new_users: z.number(),
    sessions: z.number(),
    page_views: z.number(),
  }),
  search_console: z.object({
    available: z.boolean(),
    clicks: z.number(),
    impressions: z.number(),
    ctr: z.number().nullable(),
    average_position: z.number().nullable(),
  }),
});

export type GoogleKpisResponse = z.infer<typeof GoogleKpisSchema>;
